import { FC } from 'react'
import BroadcastsTable from 'component/Broadcasts/BroadcastsTable'
import { useAppSelector } from 'hooks/reduxHooks'
import { isEqual } from 'lodash'
import BroadcastsStats from 'component/Broadcasts/BroadcastsStats'
import BroadcastsFilters from 'component/Broadcasts/BroadcastsFilters'
import { Col, Row } from 'antd'

interface PropTypes {
	clientId: string
}

const ClientBroadcasts: FC<PropTypes> = ({ clientId }) => {
	const view = useAppSelector(state => state.broadcasts.view, isEqual)
	// console.log({ clientId })

	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{view === 'LIST' ? (
				<BroadcastsTable clientId={clientId} />
			) : (
				<>
					<Row justify='end'>
						<Col>
							<BroadcastsFilters />
						</Col>
					</Row>
					<BroadcastsStats clientId={clientId} />
				</>
			)}
		</>
	)
}

export default ClientBroadcasts
